// extracted by mini-css-extract-plugin
export default {"link_slide_left":"hDuNtiNvgkPQT_xbLjRS","button_icon":"MTGWg3ZbgXVp4eHct_9X"};